export const apiConstants = {
  GetAll: 'services/app/Player/GetAll',
  Get: 'services/app/Player/Get',
};
